import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURL = '/estructura-organizacional';

/**
 * GET Unidades de Trabajo
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUnidadesDeTrabajo = async (params) => {
  try {
    const response = await API.get(`${baseURL}/unidades-de-trabajo`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Roles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRoles = async (params) => {
  try {
    const response = await API.get(`${baseURL}/grupos/`, { params });
    return response.data.map((item) => ({
      ...item,
      name: item.name.split(' - ').shift(),
    }));
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET UR Administrador
 * @param {object} values
 * @returns {Promise<object|null>}
 */
export const postURAdministrador = async (values) => {
  try {
    const response = await API.post(`${baseURL}/entidades/configuracion-de-ur-administrador/`, values);
    onSuccess(response, 'Configuración guardada correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
/**
 * GET UR Administrador
 * @param {object} values
 * @returns {Promise<object[]>}
 */
export const getCuentasDeLaEntidad = async () => {
  try {
    const response = await API.get(`${baseURL}/cuenta-de-la-entidad/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
